import { CryptoKey } from "./emunData";
import Crypto from "./crypto";
import md5 from "md5";

export default class {
  apiEndpoint = null;

  constructor(apiEndpoint) {
    this.apiEndpoint = apiEndpoint;
  }

  // also exist at backend/src/utils/petUtils.js
  getPetAvatar(petID, breedID, clinicID) {
    let clinic = clinicID ? clinicID : localStorage.getItem("CLINIC");
    if (breedID) {
      return `${this.apiEndpoint}/api/photo/${clinic}/pet/${Crypto.encrypt(
        petID,
        CryptoKey
      )}?breedID=${breedID ? md5(breedID) : ""}`;
    } else {
      return `${this.apiEndpoint}/api/photo/${clinic}/pet/${Crypto.encrypt(
        petID,
        CryptoKey
      )}`;
    }
  }

  getDefaultPetAvatar() {
    return `${this.apiEndpoint}/files/avatar_120.png`;
  }

  getStaffAvatar(staffID, clinicID) {
    let clinic = clinicID ? clinicID : localStorage.getItem("CLINIC");
    return `${this.apiEndpoint}/api/photo/${clinic}/staff/${Crypto.encrypt(
      staffID,
      CryptoKey
    )}`;
  }

  getDefaultStaffAvatar() {
    return `${this.apiEndpoint}/files/avatar_staff.png`;
  }

  getRecordImagePrefixPath(recordID, clinicID) {
    // console.log("SDKV2", "getRecordImagePrefixPath");
    let clinic = clinicID ? clinicID : localStorage.getItem("CLINIC");
    return `${this.apiEndpoint}/api/photo/${clinic}/record/${Crypto.encrypt(
      recordID,
      CryptoKey
    )}`;
  }

  getBreedImagePrefixPath() {
    // console.log("SDKV2", "getBreedImagePrefixPath");
    return `${this.apiEndpoint}/api/photo/${localStorage.getItem(
      "CLINIC"
    )}/breed`;
  }

  getInHospitalImagePrefixPathVer2(inHospitalID, clinicID) {
    // console.log("SDKV2", "getInHospitalImagePrefixPathVer2");
    let clinic = clinicID ? clinicID : localStorage.getItem("CLINIC");
    return `${this.apiEndpoint}/api/photo/${clinic}/inHospital/${Crypto.encrypt(
      inHospitalID,
      CryptoKey
    )}`;
  }

  prependRecordResourcePath(records, clinicID) {
    // console.log("SDKV2", "prependRecordResourcePath");
    let clinic = clinicID ? clinicID : localStorage.getItem("CLINIC");
    records.forEach((record) => {
      record.pdf = `${
        this.apiEndpoint
      }/api/${clinic}/pdfBinary/${Crypto.encrypt(
        record.petID,
        CryptoKey
      )}/${Crypto.encrypt(record._id, CryptoKey)}`;

      let url;
      if (record.collection == "record") {
        url = this.getRecordImagePrefixPath(record._id, clinic);
        if (record.originalClinic && clinic != record.originalClinic) {
          url = this.getRecordImagePrefixPath(
            record._id,
            record.originalClinic
          );
        }
      } else {
        const inHospitalID = record._id.replace(/\/exam.*$/, "");
        url = this.getInHospitalImagePrefixPathVer2(inHospitalID, clinic);
        if (record.originalClinic && clinic != record.originalClinic) {
          url = this.getInHospitalImagePrefixPathVer2(
            inHospitalID,
            record.originalClinic
          );
        }
      }

      // if (record.therapyImage) {
      //   record.therapyImage = record.therapyImage.map((image) => {
      //     if (!image.startsWith(url)) {
      //       return `${url}/${image}`;
      //     } else {
      //       return image;
      //     }
      //   });
      // }

      if (record.attachmentImage) {
        record.attachmentImage = record.attachmentImage.map((image) => {
          if (!image.startsWith(url)) {
            return `${url}/${image}`;
          } else {
            return image;
          }
        });
      }

      if (record.attachmentFile) {
        record.attachmentFile = record.attachmentFile.map((file) => {
          if (!file._id.startsWith(url)) {
            file._id = `${url}/${file._id}`;
          }
          return file;
        });
      }

      if (record.therapyFile) {
        record.therapyFile = record.therapyFile.map((file) => {
          if (!file._id.startsWith(url)) {
            file._id = `${url}/${file._id}`;
          }
          return file;
        });
      }

      if (record.surgeryAttachmentFile) {
        record.surgeryAttachmentFile = record.surgeryAttachmentFile.map(
          (file) => {
            if (!file._id.startsWith(url)) {
              file._id = `${url}/${file._id}`;
            }
            return file;
          }
        );
      }

      ["ultraSonicImage", "xrayImage", "ultraSonicFiles", "xrayFiles"].forEach(
        (field) => {
          if (record.exam && record.exam[field]) {
            record.exam[field] = record.exam[field].map((file) => {
              if (typeof file === "string") {
                if (!file.startsWith(url)) {
                  return `${url}/${file}`;
                } else {
                  return file;
                }
              } else {
                if (!file._id.startsWith(url)) {
                  file._id = `${url}/${file._id}`;
                }
                return file;
              }
            });
          }
        }
      );

      if (record.examTask) {
        record.examTask.forEach((task) => {
          if (Array.isArray(task.image)) {
            task.image = task.image.map((file) => {
              if (typeof file === "string") {
                if (!file.startsWith(url)) {
                  return `${url}/${file}`;
                } else {
                  return file;
                }
              } else {
                if (!file._id.startsWith(url)) {
                  file._id = `${url}/${file._id}`;
                }
                return file;
              }
            });
          }
          if (Array.isArray(task.files)) {
            task.files = task.files.map((file) => {
              if (typeof file === "string") {
                if (!file.startsWith(url)) {
                  return `${url}/${file}`;
                } else {
                  return file;
                }
              } else {
                if (!file._id.startsWith(url)) {
                  file._id = `${url}/${file._id}`;
                }
                return file;
              }
            });
          }
        });
      }

      if (record.outsourcingFile) {
        record.outsourcingFile = record.outsourcingFile.map((file) => {
          if (!file._id.startsWith(url)) {
            file._id = `${url}/${file._id}`;
          }
          return file;
        });
      }

      if (!record.surgery) record.surgery = [];
      if (!record.surgeonDoctor) record.surgeonDoctor = [];
      if (!record.assistantDoctor) record.assistantDoctor = [];
      if (!record.anesthetist) record.anesthetist = [];
      if (!record.surgeryConsumable) record.surgeryConsumable = [];
      if (!record.surgeryDrugBag) record.surgeryDrugBag = [];
      if (!record.surgeryAttachmentFile) record.surgeryAttachmentFile = [];
      if (!record.examTask) record.examTask = [];
      if (!record.chargeDivision) record.chargeDivision = [];
      if (!record.examConsumable) record.examConsumable = [];
      if (!record.label) record.label = [];
      if (!record.disease) record.disease = [];
    });
    return records;
  }
}
